import React from 'react';

interface MobileMenuItemProps {
  leftSection?: React.ReactNode;
  title: string;
  rightSection?: React.ReactNode;
}

const MobileMenuItem: React.FC<MobileMenuItemProps> = ({
  leftSection,
  rightSection,
  title
}) => {
  return (
    <div className="wrapper-menu-mobile__item">
      {leftSection}
      <p className='m-0'>{title}</p>
      {rightSection}
    </div>
  );
};

export default MobileMenuItem;
